// removed by extract-text-webpack-plugin
module.exports = {"thumb":"list-entry-image__thumb___2qSFC","img":"list-entry-image__img___FkrU_"};


//////////////////
// WEBPACK FOOTER
// ./app/components/shared/ListEntryImage/list-entry-image.scss
// module id = 940
// module chunks = 0